import { render, staticRenderFns } from "./CenterBlock.vue?vue&type=template&id=4a5de2be"
import script from "./CenterBlock.vue?vue&type=script&lang=js"
export * from "./CenterBlock.vue?vue&type=script&lang=js"
import style0 from "./CenterBlock.vue?vue&type=style&index=0&id=4a5de2be&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports